import { useEffect } from 'react';
import { CSSProperties, useState } from 'react';
import { Button, Dropdown, Stack } from 'rsuite';
interface IProps {
  account?: Record<string, any>;
  commonData?: Record<string, any>;
  stylePanel: CSSProperties;
  onClose?: any;
  handleOpen?: any;
}
const default_user_menu = [
  {
    item_id: 10225,
    visibility: 'ShowEnabled'
  }
];
const getUserMenuItems = (
  account: Record<string, any>,
  commonData: Record<string, any>
) => {
  let userMenuItems;
  const userMenu = account?.user_menu || default_user_menu;
  if (commonData?.user_menu_items) {
    // if (account?.user_menu ) {
    let userMenuCombinedItems = commonData?.user_menu_items.map(
      (item: Record<string, any>) => {
        let target = userMenu.find(
          (ele: Record<string, any>) => ele?.item_id === item?.item_id
        );
        return {
          ...item,
          ...target
        };
      }
    );
    userMenuItems = userMenuCombinedItems.filter(
      (item: Record<string, any>) => {
        return userMenu.some(
          (ele: Record<string, any>) =>
            ele?.item_id === item?.item_id && ele?.visibility !== 'Hide'
        );
      }
    );
    // }
  }

  return userMenuItems;
};

export const UserMenu = ({
  account,
  commonData,
  stylePanel,
  handleOpen,
  onClose
}: IProps) => {
  const [userMenu, setUserMenu] = useState<Record<string, any>>();
  useEffect(() => {
    if (account && commonData) {
      const userMenu = getUserMenuItems(account, commonData);
      setUserMenu(userMenu);
    }
  }, [account, commonData]);
  const h_key = {
    source_app: '',
    user_id: account?.user_id > 0 ? account?.user_id : 0,
    account_id: account?.account_id,
    user_fullaccess: account?.all_assets_access,
    partner_id: ''
  };
  if (userMenu?.length) {
    return (
      <Stack.Item style={stylePanel} className="user-menu">
        {userMenu.map((item: Record<string, any>, idx: number) => (
          <Dropdown.Item
            key={idx}
            style={{
              padding: '0px',
              cursor:
                item?.visibility === 'ShowDisabled' ? 'not-allowed' : 'pointer',
              pointerEvents:
                item?.visibility === 'ShowDisabled' ? 'none' : undefined,
              opacity: item?.visibility === 'ShowDisabled' ? '.5' : ''
            }}
          >
            {[10220, 10222].includes(item.item_id) ? (
              <Button
                onClick={() => {
                  handleOpen();
                  onClose && onClose();
                }}
                style={{
                  display: 'inline-block',
                  width: '100%',
                  whiteSpace: 'initial',
                  textAlign: 'start',
                  background: 'none'
                }}
              >
                <img
                  src={'data:image/svg+xml;base64,' + item?.image_content}
                  width="19px"
                ></img>
                {item?.display_name}
              </Button>
            ) : (
              <form method="post" action={item?.url}>
                <input
                  type="hidden"
                  name="h_key"
                  value={JSON.stringify(h_key)}
                />
                <Button
                  onClick={() => {
                    onClose && onClose();
                  }}
                  type="submit"
                  name="submit_param"
                  value="submit_value"
                  disabled={!item?.url || typeof item?.url !== 'string'}
                  style={{
                    display: 'inline-block',
                    width: '100%',
                    whiteSpace: 'initial',
                    background: 'none',
                    textAlign: 'start'
                  }}
                >
                  <img
                    src={'data:image/svg+xml;base64,' + item?.image_content}
                    width="19px"
                  ></img>
                  {' ' + item?.display_name}
                </Button>
              </form>
            )}
          </Dropdown.Item>
        ))}
      </Stack.Item>
    );
  }
  return (
    <div
      style={{
        padding: '100px'
      }}
    >
      {account?.account_id
        ? ` No User Profile Data found with Account ID:  ${account?.account_id}`
        : 'No User Profile'}
    </div>
  );
};
